<template>
  <div class="field-item" :class="{ 'is-readonly': readOnly }">
    <!-- Иконка перетаскивания -->
    <div v-if="!readOnly" class="drag-handle" title="Перетащить">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M7 7H17"
          stroke="#9ca3af"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M7 12H17"
          stroke="#9ca3af"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M7 17H17"
          stroke="#9ca3af"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </div>

    <div class="block-info">
      <span class="block-name">{{ displayName }}</span>
      <span class="block-type">({{ typeLabel }})</span>
    </div>

    <div v-if="!readOnly" class="block-controls">
      <button
        class="btn-icon edit-icon"
        @click="$emit('edit')"
        title="Редактировать"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
          ></path>
          <path
            d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
          ></path>
        </svg>
      </button>
      <button
        class="btn-remove"
        @click="$emit('remove')"
        title="Удалить"
      >
        ×
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useTemplateStore } from "@/stores/templateStore";

export default {
  name: "TemplateBlockItem",
  props: {
    block: { type: Object, required: true },
    readOnly: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useTemplateStore, ["blockTypeOptions"]),

    typeLabel() {
      if (!this.block.field_type) return "Не указан";
      const option = this.blockTypeOptions.find(
        (o) => o.value === this.block.field_type
      );
      return option ? option.label : this.block.field_type;
    },

    displayName() {
      return this.block.name || "(Без названия)";
    },
  },
};
</script>

<style scoped>
.field-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px 15px;
  background-color: #f0f0f0;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  transition: all 0.2s;
}

.field-item:not(.is-readonly):hover {
  background-color: #e5e7eb;
  border-color: #d1d5db;
}

.is-readonly {
  cursor: default;
}

.drag-handle {
  cursor: grab;
  display: flex;
  align-items: center;
  color: #9ca3af;
  flex-shrink: 0;
}
.drag-handle:active {
  cursor: grabbing;
}

.block-info {
  flex-grow: 1;
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.block-name {
  font-weight: 500;
  color: #1f2937;
  font-size: 14px;
}

.block-type {
  font-size: 13px;
  color: #6b7280;
}

.block-controls {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s, background-color 0.2s;
}
.btn-icon:hover {
  color: #111827;
  background-color: #e5e7eb;
}

.btn-remove {
  background: var(--color-danger);
  color: #fff;
  border: none;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  transition: background-color 0.2s;
}
.btn-remove:hover {
  background-color: var(--color-danger-hover);
}

@media (max-width: 480px) {
  .field-item {
    flex-wrap: wrap;
  }

  .block-info {
    width: 100%;
  }

  .block-controls {
    margin-left: auto;
    margin-top: 5px;
  }
}
</style>
